import { Formik, FormikProps } from 'formik';

import * as Styled from './styled';
import { FormProps } from './types';

export const Form = <Values,>({ className, children, ...props }: FormProps<Values>) => (
  <Formik {...props}>
    {(formikProps: FormikProps<Values>) => (
      <Styled.Form className={className} aria-label={props['aria-label']} aria-labelledby={props['aria-labelledby']}>
        {typeof children === 'function' ? children(formikProps) : children}
      </Styled.Form>
    )}
  </Formik>
);
